export default {
  PIECE_CONCEPT: 'pieces',
  WEIGHT_CONCEPT: 'weight',
};



// WEBPACK FOOTER //
// ./src/variables/transportLuggageConceptTypes.js